import {isInLabelValueArrayAsString, isValidDateTimeString, isValidPositiveNumber} from "@utils/validators";
import {PREMISE_TENURE_TYPE_OPTIONS} from "@constants/form-optins/business-insurance-options";
import {YES_NO_CHOICE_OPTIONS} from "@constants/dropdown-choices";
import {isNotStringOrEmptyString} from "@utils/string";
import {isDateGreaterThenToday} from "@utils/date-time";

export const ValidateStep5Data = (data) => {
   
   const msgList = [/*{
      name: 'halt',
      message: 'Halt'
   }*/];
   
   if(!isInLabelValueArrayAsString(data.premiseTenureType,PREMISE_TENURE_TYPE_OPTIONS)) {
      msgList.push({
         name: 'premiseTenureType',
         message: 'Please specify the type of premise tenure'
      });
   }
   
   if(!isInLabelValueArrayAsString(data.isBuildingCoverRequired,YES_NO_CHOICE_OPTIONS)) {
      msgList.push({
         name: 'isBuildingCoverRequired',
         message: 'Please specify if building cover is required'
      });
   }
   
   if(isNotStringOrEmptyString(data.maximumCashAmountToCoverOnBusinessHours)) {
      msgList.push({
         name: 'maximumCashAmountToCoverOnBusinessHours',
         message: 'Please specify the maximum cash amount to cover on business hours'
      });
   } else if(!isValidPositiveNumber(data.maximumCashAmountToCoverOnBusinessHours)) {
      msgList.push({
         name: 'maximumCashAmountToCoverOnBusinessHours',
         message: 'The maximum cash amount to cover on business hours must be a positive number or 0!'
      });
   }
   
   if(!isInLabelValueArrayAsString(data.isCashAmountCoverRequiredOutsidePremise,YES_NO_CHOICE_OPTIONS)) {
      
      msgList.push({
         name: 'isCashAmountCoverRequiredOutsidePremise',
         message: 'Please specify if cash amount cover is required outside premise'
      });
      
   } else {
      
      if('Yes' === data.isCashAmountCoverRequiredOutsidePremise) {
         
         if(!isValidPositiveNumber(data.isCashAmountCoverRequiredOutsidePremise,false)) {
            msgList.push({
               name: 'isCashAmountCoverRequiredOutsidePremise',
               message: 'The cash amount cover required outside premise must be a positive number or 0!'
            });
         }
         
      }
      
   }
   
   if(!isInLabelValueArrayAsString(data.hadAnyClaimsBeenMadeInLast5Years,YES_NO_CHOICE_OPTIONS)) {
      msgList.push({
         name: 'hadAnyClaimsBeenMadeInLast5Years',
         message: 'Please specify if any claims were made in the last 5 years'
      });
   }
   
   if(!isInLabelValueArrayAsString(data.isExemptFromPayingPAYE,YES_NO_CHOICE_OPTIONS)) {
      msgList.push({
         name: 'isExemptFromPayingPAYE',
         message: 'Please specify if you are exempt from paying PAYE'
      });
   }
   
   if(isNotStringOrEmptyString(data.employerReferenceNumber)) {
      msgList.push({
         name: 'employerReferenceNumber',
         message: 'Please specify the employer reference number'
      });
   }
   
   if(!isValidDateTimeString(data.policyStartDate)) {
      msgList.push({
         name: 'policyStartDate',
         message: 'Please specify the policy start date'
      });
   } else if(!isDateGreaterThenToday(data.policyStartDate)) {
      msgList.push({
         name: 'policyStartDate',
         message: 'The policy start date must be in the future!'
      });
   }
   
   if('Yes' !== data.termsAgreement) {
      msgList.push({
         name: 'termsAgreement',
         message: 'Please agree to the terms and conditions'
      });
   }
   
   return msgList;
   
}